import React from 'react'

function AudioRewardIcon({ width, height, className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 9.669 13.126" >
            <path id="Vector_-_2023-12-20T153026.009" data-name="Vector - 2023-12-20T153026.009" d="M9.669,5.714A.118.118,0,0,0,9.552,5.6H8.673a.118.118,0,0,0-.117.117,3.721,3.721,0,1,1-7.442,0A.118.118,0,0,0,1,5.6H.117A.118.118,0,0,0,0,5.714a4.835,4.835,0,0,0,4.249,4.8v1.5H2.12a.425.425,0,0,0-.362.469v.527a.107.107,0,0,0,.091.117H7.82a.107.107,0,0,0,.091-.117v-.527a.425.425,0,0,0-.362-.469H5.362V10.52A4.837,4.837,0,0,0,9.669,5.714ZM4.835,8.2A2.476,2.476,0,0,0,7.325,5.743V2.461a2.491,2.491,0,0,0-4.981,0V5.743A2.476,2.476,0,0,0,4.835,8.2ZM3.457,2.461a1.377,1.377,0,0,1,2.754,0V5.743a1.377,1.377,0,0,1-2.754,0Z" fill="currentcolor" opacity="0.9" />
        </svg>
    )
}

export default AudioRewardIcon